import { UserSmartHoldSettings } from "#webapp/src/hooks/useUserSmartHoldSettings/useUserSmartHoldSettings";
import { SmartHoldState, SmartHoldType } from "@clockwise/schema/v2";
import React from "react";
import { EventElementsWrap } from "../atoms/EventElementsWrap";
import { Description } from "./Description";
import { SmartHoldSettingsBrief } from "./SmartHoldSettingsBrief";

export const SettingsWrapper = ({
  type,
  allSettings,
  isOtherUsersEvent,
  calendarName,
  smartHoldState,
}: {
  type: SmartHoldType;
  allSettings: UserSmartHoldSettings | undefined;
  isOtherUsersEvent: boolean;
  calendarName: string;
  smartHoldState: SmartHoldState;
}) => {
  if (!allSettings || isOtherUsersEvent) {
    return (
      <EventElementsWrap name="info">
        <Description calendarName={calendarName} type={type} smartHoldState={smartHoldState} />
      </EventElementsWrap>
    );
  } else {
    return (
      <EventElementsWrap name="settings">
        <SmartHoldSettingsBrief type={type} allSettings={allSettings} />
      </EventElementsWrap>
    );
  }
};
